<template>
  <p v-bind="$attrs" class="text-h5">
    <slot></slot>
  </p>
</template>

<script>
export default {
}
</script>
